/****
 *  在此文件中做 导航守卫
 * *****/
import router from "@/router";
import store from "@/store";
router.beforeEach(function(to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");

    let meta = document.createElement("meta");

    meta.content = to.meta.content;
    meta.name = to.meta.contentName;

    head[0].appendChild(meta);
  }
  if (to.path.startsWith("/user") && !store.state.user.token) {
    next({
      path: "/login",
      query: {
        redirectUrl: to.fullPath
      }
    });
  } else {
    next();
  }
});
